<template>
  <b-form>
    <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
    <b-form-group description="Your Email">
      <b-form-input type="email" placeholder="Email" v-model="email"></b-form-input>
    </b-form-group>
    <b-form-group>
      <b-button
        class="px-4"
        variant="primary"
        v-on:click="resetPassword"
        :disabled="disabledBtn"
      >Reset</b-button>
    </b-form-group>
    <p
      class="error"
      v-for="(error, key) in errors"
      :key="key"
    >{{error}}</p>
  </b-form>
</template>

<script>
  import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
  import VueLoading from "vue-loading-overlay/src/js/Component";

  export default {
    name: 'forgot-password-form',
    components: {
      VueLoading,
    },
    data() {
      return {
        email: null,
        isLoading: false,
        disabledBtn: false,
        errors: []
      }
    },
    methods: {
      resetPassword() {
        this.isLoading = true,
        RepositoryFactory
          .get('user')
          .resetPassword(this.email)
          .then(
            ()=> {
              this.disabledBtn = true;
              this.isLoading = false;
              this.$emit('success')
            }
          ).catch(
            reason => {
              this.isLoading = false;
              this.errors = reason.response.data.errors;
            }
        )
      }
    }
  }
</script>
